import { render, staticRenderFns } from "./shifu_nearby.vue?vue&type=template&id=669ba6d7&scoped=true&"
import script from "./shifu_nearby.vue?vue&type=script&lang=js&"
export * from "./shifu_nearby.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669ba6d7",
  null
  
)

export default component.exports